<template>
  <div class="cart-page page">
    <div class="page-header">
      <div class="container">
        <h1 class="title">{{ $t('pagetitle.cart') }}</h1>
      </div>
    </div>
    <div class="page-body">
      <div class="container">
        <el-row v-if="!beers || beers.length < 1" class="page-message" type="flex" justify="center">
          <span>Your cart is empty.</span>
        </el-row>
        <el-row v-else>
          <div class="cartrow">
            <div class="cart-box">
              <div class="main-col">
                <div class="main-body">
                  <item-beer @cartupdate="onCartUpdate" v-for="(beer, index) in beers" :key="index" :item="beer" @priceChange="onPriceChange($event)">
                  </item-beer>
                </div>
              </div>
              <div class="side-col">
                <div class="cart-body">
                  <span class="title">Total</span>
                  <span class="totalprice-text">{{ $t('currency.malaysia') }} {{ totalprice.toFixed(2) }}</span>
                  <el-form :rules="rules" :label-position="'top'" ref="form" :model="form" label-width="100px">
                    <div class="check-box">
                      <div class="checkitem">
                        <el-checkbox class="tnc" name="checkbox" label="" v-model="form.checkbox"></el-checkbox>
                        <div class="checktext">
                          <span>I have read and agree to <el-button type="text" class="orange-text-button tnc-button" @click="onTnCClick">Terms &amp; Conditions</el-button></span>
                        </div>
                      </div>
                      <div v-if="!isValid" class="check-error">
                        Please check to proceed
                      </div>
                      <!-- <span>
                        Prices for half and full cases in the final invoice that we will issue to you may vary slightly due to rounding.
                      </span> -->
                    </div>
                    <div class="polabel">
                      <span>Order Date: {{ today }}</span>
                    </div>
                    <el-form-item label="">
                      <el-input
                        v-model="form.note"
                        type="textarea"
                        maxlength="500"
                        :autosize="{ minRows: 3, maxRows: 4}"
                        placeholder="Add note (Maximum 500 characters)">
                      </el-input>
                    </el-form-item>
                    <div class="polabel">
                      <span>Please ensure that you upload your Purchase Order and any relevant documents, if you need our driver to produce these documents at your outlet upon delivery.</span>
                    </div>
                    <el-form-item label="">
                      <el-input v-model="form.ponumber" placeholder="Your Company's PO Number"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-upload
                        action=""
                        :auto-upload="false"
                        :on-change="handleChange"
                        :on-remove="handleRemove"
                        :before-upload="beforeAvatarUpload"
                        :limit="1">
                        <el-button class="upload-button" icon="el-icon-upload2" slot="trigger" size="small" type="primary">
                          select file
                        </el-button>
                        <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 2MB.</div>
                      </el-upload>
                    </el-form-item>
                  </el-form>
                  <el-button class="orange-button" @click="onSubmit()">
                    {{ $t('button.submitorder') }}
                  </el-button>
                  <div v-if="!isValid" class="error-msg">
                    Please check T&amp;C to proceed
                  </div>
                  <span class="note">
                    Orders will be processed on business days only.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import ItemBeer from './ItemList.vue'
export default {
  name: 'cart',
  components: {
    ItemBeer
  },
  data () {
    return {
      rules: {
        checkbox: [
          { required: true, message: 'Please check this box if you want to proceed.', trigger: 'change' }
        ]
      },
      fileObj: undefined,
      beers: [],
      labelPosition: 'left',
      step: 6,
      form: {
        checkbox: false,
        quantity: 6,
        ponumber: '',
        note: ''
      },
      totalprice: 0.00,
      today: '',
      isValid: true
    }
  },
  created () {
    this.onLoad()
  },
  mounted () {
    if (this.$store.getters.note) {
      this.form.note = this.$store.getters.note
    }
    // const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }
    const now = new Date(Date.now())
    const locale = this.$moment(now).tz('Asia/Kuala_Lumpur').format('dddd, DD MMM YYYY')
    this.today = locale
  },
  methods: {
    handleChange (file, fileList) {
      if (file) {
        this.fileObj = {
          name: 'files[0]',
          raw: file.raw,
          filename: file.name
        }
      }
    },
    handleRemove (file, fileList) {
      this.fileObj = undefined
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('Avatar picture must be JPG or PNG format!')
      }
      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    onItemClick (name, obj) {
      this.$router.push({ path: `/beer`, query: { id: obj.id, name: obj.description } })
    },
    onLoad () {
      let value = this.$store.getters.cartbeers
      this.beers = value
      this.getTotalPrice(this.beers)
    },
    onCartUpdate () {
      this.onLoad()
    },
    roundUp (value) {
      return parseFloat((Math.round(value * 100) / 100).toFixed(2))
    },
    onPriceChange (val) {
      this.getTotalPrice(this.beers)
    },
    getTotalPrice (list) {
      if (list) {
        let tempprice = 0
        list.forEach((item) => {
          tempprice += this.roundUp(item.beer.user_price * item.quantity)
        })
        this.totalprice = this.roundUp(tempprice)
      }
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid && this.form.checkbox) {
          this.$store.dispatch('SetNote', this.form.note)
          const data = {
            userId: this.$store.getters.id,
            email: this.$store.getters.email,
            groupId: this.$store.getters.groupid,
            addressId: '',
            subTotal: this.totalprice,
            inventory: this.beers,
            poNumber: this.form.ponumber,
            note: this.form.note,
            file: this.fileObj
          }
          this.$router.push({ name: 'Confirmation', params: { data } })
        } else {
          this.isValid = false
        }
      })
    },
    onTnCClick () {
      this.$alert(
        '<ul style="list-style-type: decimal;padding-left: 15px;">' +
        '<li>Orders will be processed on business days only.</li>' +
        '<li>Orders will only be processed upon payment of all overdue amounts.</li>' +
        '<li>MyBeer (M) Sdn Bhd may, in its discretion, cancel or amend your credit limit without notice.</li>' +
        '<li>The inventory balance is updated every morning. MyBeer (M) Sdn Bhd cannot guarantee the availability of beers throughout the day.</li>' +
        '<li>Submitted orders cannot be cancelled or edited online. Please contact us if you wish to cancel or edit your order.</li>' +
        '<li>Invoice price may vary slightly due to rounding.</li>' +
        '</ul>',
        'Terms & Conditions', {
          dangerouslyUseHTMLString: true
        }
      )
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/settings.scss";
.cart-page {
  // .el-form {
  //   padding-bottom: 25px;
  // }
  // .el-form-item__label {
  //   color: #1C1C1C;
  //   font-size: 18px;
  // }
  .el-upload__tip {
    font-size: 12px;
    @media (min-width: 768px) {
      font-size: 14px;
    }
  }
  .checkitem {
    .tnc {
      align-items: center;
      justify-content: center;
      display: flex;
    }
    .tnc-button {
      font-size: 14px;
      @media (min-width: 768px) {
        font-size: 16px;
      }
    }
  }
  .el-form-item__label, .el-checkbox__label {
    color: #1C1C1C;
    font-size: 16px;
  }
  .el-input--medium .el-input__inner {
    height: 46px;
    line-height: 46px;
  }
  .el-input__inner, .el-textarea__inner, .el-checkbox__label {
    font-family: 'Lato', 'Helvetica Neue', Helvetica,'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    font-size: 16px;
    border-radius: 0px;
    padding: 10px 15px;
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
  .el-upload {
    width: 100%;
  }
  .container {
    padding: 0;
    @media (min-width: 768px) {
      padding: 50px 0;
    }
  }
  .page-body {
    background-color: $white-color;
  }
  .polabel {
    line-height: 25px;
    font-size: 14px;
    padding-bottom: 15px;
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
  .check-box {
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
    .checkitem {
      display: flex;
    }
    .checktext {
      padding-left: 10px;
    }
    .check-error {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
    }
  }
  .cartrow {
    .cart-box, .item-box {
      width: 100%;
      display: flex;
      align-items: left;
      justify-content: left;
      flex-direction: row;
      flex-wrap: wrap;
      flex-flow: row wrap;
      align-content: flex-end;
    }
    .cart-box {
      & > .main-col {
        margin-top: 25px;
        .orange-button {
          letter-spacing: 1px;
        }
        .main-body {
          padding-right: 15px;
          @media (min-width: 768px) {
            padding-right: 25px;
          }
        }
      }
      & > .side-col {
        background-color: #efefef;
        margin-bottom: 25px;
        .orange-button {
          max-width: 100%;
          width: 100%;
        }
      }
      & > .main-col, & > .side-col {
        width: 100%;
        @media (min-width: 768px) {
          width: 50%;
        }
      }
      & > .main-col, & > .side-col {
        .cart-poster {
          padding-right: 25px;
          & >img {
            width: 100%;
          }
        }
        .cart-body {
          padding: 15px;
          @media (min-width: 768px) {
            padding: 25px;
          }
          & > .title {
            color: $black-color;
            font-weight: bold;
            font-size: 24px;
            @media (min-width: 768px) {
              font-size: 28px;
            }
          }
          & > span {
            display: block;
            padding-bottom: 10px;
            @media (min-width: 768px) {
              padding-bottom: 20px;
            }
          }
          .totalprice-text {
            color: $black-color;
            font-weight: bold;
            font-size: 26px;
            @media (min-width: 768px) {
              font-size: 30px;
            }
          }
          .error-msg {
            padding-top: 15px;
            font-weight: bold;
            color: $danger-color;
            text-align: center;
          }
          .note {
            padding-top: 15px;
            font-size: 14px;
            @media (min-width: 768px) {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cart/index.vue